const openCloseAddGroup = (state, action) => ({
  ...state,
  createGroupDialogOpenFor: action.payload.createGroupDialogOpenFor,
});

export default openCloseAddGroup;
